const detectTimezone = {
	sookiename: "timezone_info",
	sookiehash: "c012ce7bb343ebee389e48f513824fa79d66c436",
	offset: 0,

	initialize: function(sookie) {
		// factor in DST if it's set
		// (i.e., work with old sookies)
		if (sookie && sookie.is_dst && sookie.dst_offset) {
			sookie.offset += sookie.dst_offset;
		}

		const offset = 0 - (new Date().getTimezoneOffset());

		if (!sookie || offset != sookie.offset) {
			this.update(offset);
			if (typeof window.util !== "undefined" && window.util.updateStats)
			{ window.util.updateStats("timezone updated", 1, "counter", "X3U+IfBEBIpAECH/gapKGTmDE64="); }
		}
	},

	update: function(offset) {
		if (offset == null) return;

		const now = new Date().getTime();
		const t = Math.floor(now / 1000) + 86400 * 365 * 5;
		const newsookie = { offset: offset };

		if (typeof AjaxSookie !== "undefined" && window.AjaxSookie.set) {
			window.AjaxSookie.set(this.sookiename, newsookie, t, this.sookiehash);
		} else if (typeof App !== "undefined" && window.App.setSookie) {
			window.App.setSookie(this.sookiename, newsookie, t, this.sookiehash);
		} else if (typeof window.util !== "undefined" && window.util.setSookie) {
			window.util.setSookie(this.sookiename, newsookie, t, this.sookiehash);
		}
	},
};

window.DetectTimezone = detectTimezone;
export default detectTimezone;



// WEBPACK FOOTER //
// ./src/legacy/Timezone.js